// extracted by mini-css-extract-plugin
export default {"container":"_1RXdlJKYLkiw5Z4TE51zpp"};